var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2060DigitalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 24,
    viewBox: "0 0 125 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_630_8190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7001 8.23608e-05C39.5045 8.23608e-05 36.1075 2.26815 36.1075 6.47599V8.19285C35.1756 6.6537 33.5703 5.63261 31.5952 5.63261C31.4509 5.63261 31.3156 5.63261 31.1833 5.64165L35.1034 0.596468L35.2267 0.442853H30.1642L25.1529 6.77117C24.8703 7.18683 24.6148 7.61755 24.3953 8.06334V6.43081C24.3953 2.76514 21.5815 8.23608e-05 17.8478 8.23608e-05C15.497 8.23608e-05 13.0409 1.22599 11.9046 3.54828C11.2282 1.52117 9.14186 8.23608e-05 6.29499 8.23608e-05C2.4711 8.23608e-05 0 2.56936 0 6.58743H4.1696C4.2628 4.729 4.93318 3.87056 6.13867 3.87056C7.08863 3.87056 7.76202 4.54526 7.76202 5.54225C7.76202 6.86454 6.69482 8.6296 4.7498 10.6055C3.79984 11.5814 2.2787 12.7862 0.168347 14.1567V17.5694H8.6729L11.3725 14.1567H11.3364L6.21382 14.1416C8.724 11.985 10.3534 10.1206 11.2552 8.3796V11.4639C11.2552 15.1959 14.1081 18.0091 17.8959 18.0091C20.815 18.0091 23.1117 16.3555 23.9985 13.8495C24.9274 16.4007 27.3174 18.0091 30.3416 18.0091C33.3659 18.0091 35.5965 16.3676 36.5464 13.9037C37.4874 16.3555 39.8412 18.0091 42.7422 18.0091C46.509 18.0091 49.2416 15.2561 49.2416 11.4639V6.42779C49.2416 2.76213 46.4278 -0.00292969 42.6941 -0.00292969L42.7001 8.23608e-05ZM19.6666 11.8465C19.6666 12.9007 19.3479 14.1567 17.8268 14.1567C16.6754 14.1567 15.987 13.2923 15.987 11.8465V6.18683C15.987 4.76213 16.6934 3.87659 17.8268 3.87659C19.3479 3.87659 19.6666 5.13261 19.6666 6.18683V11.8465ZM30.2063 14.1567C28.8385 14.1567 27.8885 13.0663 27.8885 11.7651C27.8885 10.4639 28.9077 9.48803 30.2063 9.48803C31.5742 9.48803 32.6143 10.5091 32.6143 11.8344C32.6143 13.1597 31.5711 14.1567 30.2063 14.1567ZM44.5159 11.8465C44.5159 12.9007 44.1972 14.1567 42.6761 14.1567C41.5247 14.1567 40.8363 13.2923 40.8363 11.8465V6.18683C40.8363 4.76213 41.5427 3.87659 42.6761 3.87659C44.1972 3.87659 44.5159 5.13261 44.5159 6.18683V11.8465Z",
    fill: "url(#paint0_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.786 1.09639C62.5234 0.391566 60.7497 0 58.5161 0H52.3955V18.009H58.8318C64.4414 18.009 67.9406 14.9428 67.9406 9.00301C67.9406 5.32831 66.3383 2.55422 63.786 1.09337V1.09639ZM59.0482 14.1506H56.983V3.87349H59.0723C61.7208 3.87349 63.3471 5.81626 63.3471 9.03012C63.3471 12.244 61.6937 14.1506 59.0482 14.1506Z",
    fill: "url(#paint1_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2979 0H69.2666V3.07229H73.2979V0Z",
    fill: "url(#paint2_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2979 4.49707H69.2666V18.0121H73.2979V4.49707Z",
    fill: "url(#paint3_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1839 5.75601H85.1358C84.4805 4.71083 83.1457 4.0542 81.3961 4.0542C77.5121 4.0542 74.6201 7.19275 74.6201 11.3283C74.6201 15.4638 77.461 18.4307 81.3961 18.4307C83.0465 18.4307 84.5526 17.7018 85.1599 16.4126V16.8012C85.1599 19.259 83.9213 20.5964 81.8831 20.5964C80.8881 20.5964 79.9892 20.256 79.5292 19.259H74.8666C75.2063 21.8373 77.6834 24.003 81.4953 24.003C84.8713 24.003 87.5167 22.5693 88.4877 20.6958C88.9747 19.7711 89.2152 18.3855 89.2152 16.5602V4.49095H85.1839V5.75601ZM81.853 14.6596C79.911 14.6596 78.6244 13.0783 78.6244 11.1807C78.6244 9.28311 80.0583 7.82528 81.853 7.82528C83.8191 7.82528 85.1569 9.33432 85.1569 11.3042C85.1569 13.2741 83.8221 14.6626 81.853 14.6626V14.6596Z",
    fill: "url(#paint4_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5841 4.49707H90.5527V18.0121H94.5841V4.49707Z",
    fill: "url(#paint5_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5841 0H90.5527V3.07229H94.5841V0Z",
    fill: "url(#paint6_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.946 0H97.9149V4.49699H95.9248V7.56928H97.9149V18.009H101.946V7.56928H103.891V4.49699H101.946V0Z",
    fill: "url(#paint7_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.948 5.93665H114.9C114.125 4.69569 112.595 4.03906 110.944 4.03906C107.084 4.03906 104.195 7.24991 104.195 11.2409C104.195 15.2318 106.964 18.4668 110.944 18.4668C112.718 18.4668 114.32 17.7379 114.9 16.5451H114.948V18.0089H118.98V4.50292H114.948V5.93966V5.93665ZM111.576 14.6957C109.706 14.6957 108.224 13.1626 108.224 11.2891C108.224 9.41557 109.682 7.81015 111.524 7.81015C113.367 7.81015 114.948 9.34328 114.948 11.2409C114.948 13.1385 113.466 14.6957 111.573 14.6957H111.576Z",
    fill: "url(#paint8_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.333 0V18.009H124.364V0H120.333ZM123.922 17.5663H120.775C122.2 16.3253 123.231 15.2018 123.922 14.1506V17.5663Z",
    fill: "url(#paint9_linear_630_8190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.922 17.5665H120.774C122.199 16.3256 123.23 15.2021 123.922 14.1509V17.5665Z",
    fill: "url(#paint10_linear_630_8190)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_630_8190",
    x1: 25.9526,
    y1: -3.53305,
    x2: 23.8793,
    y2: 15.8968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_630_8190",
    x1: 60.9271,
    y1: -5.43675,
    x2: 58.8569,
    y2: 22.2614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_630_8190",
    x1: 71.7407,
    y1: -4.62651,
    x2: 69.6705,
    y2: 23.0687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_630_8190",
    x1: 72.4592,
    y1: -4.57522,
    x2: 70.389,
    y2: 23.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_630_8190",
    x1: 83.2509,
    y1: -3.76809,
    x2: 81.1807,
    y2: 23.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_630_8190",
    x1: 93.6311,
    y1: -2.99088,
    x2: 91.5578,
    y2: 24.7073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_630_8190",
    x1: 92.9096,
    y1: -3.04518,
    x2: 90.8394,
    y2: 24.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_630_8190",
    x1: 100.539,
    y1: -2.47289,
    x2: 98.4691,
    y2: 25.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_630_8190",
    x1: 112.781,
    y1: -1.56034,
    x2: 110.711,
    y2: 26.1379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_630_8190",
    x1: 123.081,
    y1: -0.789157,
    x2: 121.007,
    y2: 26.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_630_8190",
    x1: 123.892,
    y1: 12.8015,
    x2: 122.236,
    y2: 17.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B549"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_630_8190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.364,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2060DigitalLogo);
export default __webpack_public_path__ + "static/media/2060Digital-logo.554a40cea7e795ac2599c021a3cc534d.svg";
export { ForwardRef as ReactComponent };